import type { User } from '@/services/auth.service';

export function isSuperAdmin(user: User | null): boolean {
    return Boolean(user?.is_superuser);
}

export function isStaffAdmin(user: User | null): boolean {
    return Boolean(user?.is_staff);
}

/**
 * Superadmin or staff tenant operator. Admin JWT login already requires `is_staff`,
 * so this is true for any logged-in user here; the API still enforces authorization.
 */
export function canManageTenantPermissionSettings(user: User | null): boolean {
    if (!user) return false;
    return Boolean(user.is_superuser || user.is_staff);
}

/**
 * EAA-1212: platform staff = `is_staff || is_superuser`. SSO super admins arrive from
 * `/auth/me` as `is_staff: true, is_superuser: false`, so `isSuperAdmin` alone would
 * hide platform-only screens from exactly the people who run the platform.
 */
export function isPlatformStaff(user: User | null): boolean {
    return Boolean(user?.is_staff || user?.is_superuser);
}

/**
 * EAA-1212: the system-settings screen changes platform-wide configuration, so it is
 * offered only to platform staff, and never inside the tenant portal (whose session
 * acts for one tenant even when the identity behind it is staff).
 */
export function canOpenSystemSettings(user: User | null, authMode: string | null | undefined): boolean {
    return isPlatformStaff(user) && authMode !== 'tenant';
}
